
export default function Trust() {
  const badges = [
    {
      icon: 'ri-shield-check-line',
      title: 'Insured & Bonded',
      description: 'Protección completa para tu tranquilidad'
    },
    {
      icon: 'ri-award-line',
      title: 'Satisfaction Guaranteed',
      description: '100% garantía de satisfacción o regresamos'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Background-checked',
      description: 'Equipo verificado y de confianza'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-r from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-outfit">
            Tu confianza es nuestra prioridad
          </h2>
          <p className="text-slate-300 text-lg font-inter">
            Respaldamos nuestro trabajo con garantías sólidas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {badges.map((badge, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-sky-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${badge.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2 font-outfit">
                {badge.title}
              </h3>
              <p className="text-slate-300 font-inter">
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
